import PropTypes from 'prop-types';

import {
  atgBetType,
  atgCalendarBetParams,
  sportCalendarBetParams,
  sportProduct,
} from 'shared/proptypes';

export const sportEvent = PropTypes.shape({
  id: PropTypes.number.isRequired,
  betParams: sportCalendarBetParams.isRequired,
  openTime: PropTypes.number.isRequired,
  closeTime: PropTypes.number.isRequired,
  updatedTime: PropTypes.number.isRequired,
  turnover: PropTypes.number,
  jackpotAmount: PropTypes.string,
});

export const atgCalendarHighlight = PropTypes.shape({
  trackName: PropTypes.string.isRequired,
  betParams: atgCalendarBetParams.isRequired,
  jackpotAmount: PropTypes.string,
});

export const calendarJackpot = PropTypes.shape({
  product: PropTypes.string.isRequired,
  amount: PropTypes.string.isRequired,
  date: PropTypes.number.isRequired,
  betParams: PropTypes.oneOfType([atgCalendarBetParams, sportCalendarBetParams])
    .isRequired,
});

export const atgBetTipsProvider = PropTypes.shape({
  provider: PropTypes.string.isRequired,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      product_id: PropTypes.number.isRequired,
      description: PropTypes.string.isRequired,
      bet_type: atgBetType.isRequired,
      trackName: PropTypes.string.isRequired,
      raceDate: PropTypes.number.isRequired,
      store: PropTypes.string,
      tips: PropTypes.arrayOf(
        PropTypes.shape({
          betId: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          paid: PropTypes.bool.isRequired,
        }),
      ).isRequired,
    }),
  ),
});

export const sportBetTipsProvider = PropTypes.shape({
  provider: PropTypes.string.isRequired,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      blurb: PropTypes.string.isRequired,
      drawNr: PropTypes.number.isRequired,
      id: PropTypes.number.isRequired,
      product: sportProduct.isRequired,
      closeTime: PropTypes.number,
      betPublications: PropTypes.arrayOf(
        PropTypes.shape({
          betId: PropTypes.number.isRequired,
          name: PropTypes.string,
        }),
      ),
    }).isRequired,
  ),
});
